/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Companydetailsregistrationnumber3Inputs */

const en_companydetailsregistrationnumber3 = /** @type {(inputs: Companydetailsregistrationnumber3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company register, ZVR or GISA number`)
};

const de_companydetailsregistrationnumber3 = /** @type {(inputs: Companydetailsregistrationnumber3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmenbuch-, ZVR- oder GISA-Nummer`)
};

/**
* | output |
* | --- |
* | "Company register, ZVR or GISA number" |
*
* @param {Companydetailsregistrationnumber3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const companydetailsregistrationnumber3 = /** @type {((inputs?: Companydetailsregistrationnumber3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Companydetailsregistrationnumber3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_companydetailsregistrationnumber3(inputs)
	return de_companydetailsregistrationnumber3(inputs)
});
export { companydetailsregistrationnumber3 as "companyDetailsRegistrationNumber" }